import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import TrustBar from '../../components/feature/TrustBar';
import PlatformPartners from '../../components/feature/PlatformPartners';
import AIAnswerBlock, { AIAnswer } from '../../components/feature/AIAnswerBlock';
import Process, { ProcessStep } from '../../components/feature/Process';
import WhyChooseUs from '../../components/feature/WhyChooseUs';
import ServiceAreas from '../../components/feature/ServiceAreas';
import Testimonials from '../../components/feature/Testimonials';
import FAQ from '../../components/feature/FAQ';
import FinalCTA from '../../components/feature/FinalCTA';
import ContactHero from './components/Hero';
import ContactServicesOverview from './components/ServicesOverview';

const contactAnswers: AIAnswer[] = [
  {
    q: 'How do I get started with ECS?',
    a: 'Call 405-408-1117 or submit the contact form. ECS will review your current compliance situation, identify what needs to be done on your ISNetworld, Veriforce, or Avetta account, and provide a clear path to 100% compliance — typically within one business day of initial contact.',
  },
  {
    q: 'What information should I have ready when I contact ECS?',
    a: "Have your current compliance platform details available — your ISNetworld, Veriforce, or Avetta account information, company name, and any specific compliance challenges you're facing. ECS can work with accounts at any stage, from brand new to needing urgent improvements.",
  },
  {
    q: 'How quickly can ECS begin managing my compliance?',
    a: 'ECS can begin working on new and existing accounts quickly after initial contact. New account setups are handled with quick turnaround, and existing accounts needing improvement can see immediate work begin once your situation is assessed and you decide to proceed.',
  },
  {
    q: 'Does ECS require a contract or long-term commitment?',
    a: 'No contracts. ECS operates month-to-month — you can cancel at any time with no penalties or long-term obligations. This flexible model means you\'re never locked in and always in control of your compliance management relationship.',
  },
];

const contactSteps: ProcessStep[] = [
  {
    number: '01',
    title: 'Reach Out',
    description:
      'Call 405-408-1117 or submit the contact form. Tell us which platform(s) you need help with and where you currently stand with your compliance.',
  },
  {
    number: '02',
    title: 'Same-Day Response',
    description:
      'A dedicated ECS expert reviews your situation and follows up within one business day — often the same day — with a clear assessment and next steps.',
  },
  {
    number: '03',
    title: 'We Get to Work',
    description:
      'Once you\'re ready to proceed, we begin immediately. No long intake process, no waiting period. Compliance work starts right away on your accounts.',
  },
  {
    number: '04',
    title: 'You Stay Compliant',
    description:
      'With your accounts managed on an ongoing basis, you stay approved month after month — with no contracts holding you in and no compliance gaps threatening your contracts.',
  },
];

export default function Contact() {
  return (
    <main>
      {/* 1. Hero */}
      <Navbar />
      <ContactHero />
      {/* 2. Trust Bar */}
      <TrustBar />
      {/* Platform Showcase */}
      <PlatformPartners />
      {/* 3. Services Overview (Lead Form) */}
      <ContactServicesOverview />
      {/* 4. AI Answer Block */}
      <AIAnswerBlock
        answers={contactAnswers}
        headline="Getting Started Is Simple"
        subtext="Common questions from contractors reaching out to ECS for the first time — answered clearly and directly."
      />
      {/* 5. Process */}
      <Process
        steps={contactSteps}
        headline="From First Contact to Full Compliance"
        subheadline="What happens after you reach out to ECS — a transparent, fast-moving process designed around your timeline."
      />
      {/* 6. Why Choose Us */}
      <WhyChooseUs />
      {/* 7. Service Areas */}
      <ServiceAreas />
      {/* 8. Testimonials */}
      <Testimonials />
      {/* 9. FAQ */}
      <FAQ />
      {/* 10. Final CTA */}
      <FinalCTA />
      <Footer />
    </main>
  );
}
